import backgroundImageUrl from "img/background.jpg"
import { Wrapper } from "components/Wrapper"
import { Flag } from "components/Icon"
import { Text } from "components/Text"

export const Hero = (props) => {
  return (
    <section
      className={"relative flex flex-col justify-end py-8"}
      style={{ height: 480 }}
    >
      <img
        src={props.backgroundImage || backgroundImageUrl}
        alt=""
        className="object-cover object-bottom absolute top-0 left-0 w-full h-full"
        loading={"lazy"}
      />
      <Wrapper>
        <div className="relative space-y-4">
          <div className="flex items-center space-x-2">
            <Flag className="w-8 text-secondary-default" />
            <Text
              variant="headline1"
              tag="h1"
              className="text-white text-shadow-lg"
            >
              {props.title}
            </Text>
          </div>
        </div>
      </Wrapper>
    </section>
  )
}
